/* src/app/shared/components/ag-checkbox-v2/ag-checkbox-v2.component.scss */
.relative {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.relative:hover .ag-checkbox-hover-icon {
  visibility: visible;
}
.relative .ag-checkbox-hover-icon {
  position: absolute;
  visibility: hidden;
  pointer-events: none;
}
.relative .ag-checkbox-checked-icon-small {
  height: 14px;
  width: 14px;
  position: absolute;
  color: #ffffff;
  pointer-events: none;
}
.relative .ag-checkbox-checked-icon-default {
  height: 16px;
  width: 16px;
  position: absolute;
  color: #ffffff;
  pointer-events: none;
}
.relative .ag-checkbox-checked-icon-large {
  height: 16px;
  width: 16px;
  position: absolute;
  color: #ffffff;
  pointer-events: none;
}
.relative .radio-button-checked-icon-small {
  height: 8px;
  width: 8px;
  position: absolute;
  color: #ffffff;
  pointer-events: none;
}
.relative .radio-button-checked-icon-default {
  height: 12px;
  width: 12px;
  position: absolute;
  color: #ffffff;
  pointer-events: none;
}
.relative .radio-button-checked-icon-large {
  height: 16px;
  width: 16px;
  position: absolute;
  color: #ffffff;
  pointer-events: none;
}
.ag-checkbox {
  -webkit-appearance: none;
  border: solid 1px #a6a6a6;
  background-color: #ffffff;
  cursor: pointer;
  outline: none;
}
.ag-checkbox.ag-size-small {
  height: 20px;
  width: 20px;
  border-radius: 6px;
}
.ag-checkbox.ag-size-default {
  height: 24px;
  width: 24px;
  border-radius: 6px;
}
.ag-checkbox.ag-size-large {
  height: 32px;
  width: 32px;
  border-radius: 10px;
}
.ag-checkbox:hover {
  border-color: #222222;
}
.ag-checkbox:focus-visible {
  box-shadow: 0px 0px 0px 1px #3ea2ff;
}
.ag-checkbox:checked {
  border-color: #222222;
}
.ag-checkbox:checked.black-input-filter {
  background-color: #222222 !important;
}
.ag-checkbox.has-errors {
  border: solid 2px #e55e5e;
  background-color: #fff2f0;
}
.ag-checkbox.disabled-checkbox {
  opacity: 0.6;
  border: solid 1px #a6a6a6 !important;
  background-color: #f2f2f2;
}
.radio-button {
  -webkit-appearance: none;
  border: solid 1px #a6a6a6;
  background-color: #ffffff;
  cursor: pointer;
  outline: none;
}
.radio-button.ag-size-small {
  height: 20px;
  width: 20px;
  border-radius: 12px;
}
.radio-button.ag-size-default {
  height: 24px;
  width: 24px;
  border-radius: 12px;
}
.radio-button.ag-size-large {
  height: 32px;
  width: 32px;
  border-radius: 16px;
}
.radio-button:hover {
  border-color: #222222;
}
.radio-button:focus-visible {
  box-shadow: 0px 0px 0px 1px #3ea2ff;
}
.radio-button:checked {
  border-color: #222222;
}
.radio-button:checked.black-input-filter {
  background-color: #222222 !important;
}
.radio-button.has-errors {
  border: solid 2px #e55e5e;
  background-color: #fff2f0;
}
.radio-button.disabled-checkbox {
  opacity: 0.6;
  border: solid 1px #a6a6a6 !important;
  background-color: #f2f2f2;
}
.white-img-filter {
  filter: brightness(0) invert(1);
}
.checkbox-label {
  padding-left: 12px;
  color: #222222;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.checkbox-subtitle {
  color: #5c5c5c;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.checkbox-subtitle.ag-size-small {
  margin-left: 34px;
}
.checkbox-subtitle.ag-size-default {
  margin-left: 37px;
}
.checkbox-subtitle.ag-size-large {
  margin-left: 46px;
}
.disabled {
  color: #a6a6a6;
  filter: brightness(0) saturate(100%) invert(65%);
}
/*# sourceMappingURL=ag-checkbox-v2.component.css.map */
